import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';

import './index.css';

import './i18n/i18n';

import { App } from './components/App/App';

import generateStore from './redux/store';

const store = generateStore();

ReactDOM.render(
  <React.Suspense fallback={<>Loading...</>}>
    <Provider store={store}>
      <App />
    </Provider>
  </React.Suspense >,
  document.getElementById('root'),
);
